import React from 'react';
import {Anchor, Breadcrumbs} from "@mantine/core";
import {useNavigate} from "react-router-dom";
import S from './Article2.module.scss';
import article1 from "../../shared/assets/images/article1.png";
import article2 from "../../shared/assets/images/article2.png";
import article3 from "../../shared/assets/images/article3.png";
import article4 from "../../shared/assets/images/article4.png";

export const Article2 = () => {
    const navigate = useNavigate();

    const items = [
        { title: 'Главная', url: '/' },
        { title: 'Статьи', url: '/articles-list' },
        { title: 'Статья', active: true },
    ].map((item, index) => (
        <Anchor onClick={() => item.url && navigate(item.url)} key={index} data-active={item.active || undefined}>
            {item.title}
        </Anchor>
    ));

    return (
        <section id='article2'>
            <div className={S.content}>
                <div>
                    <Breadcrumbs>
                        {items}
                    </Breadcrumbs>
                    <div className={S.infoDiv}>
                        <div className={S.title}>ЦИФРОВИЗАЦИЯ ЭКОНОМИЧЕСКИХ ОТНОШЕНИЙ В ЭНЕРГЕТИКЕ</div>
                        <div className={S.picture}>
                            <img src={article2} alt="article2"/>
                        </div>
                        <div className={S.textDiv}>
                            <div className={S.text}>
                                Цифровизация в энергетике охватывает широкий круг вопросов, включая управление
                                энергоресурсами, развитие интеллектуальных энергосетей, интеграцию возобновляемых
                                источников энергии, автоматизацию производственных процессов и повышение качества
                                обслуживания потребителей. В условиях нарастающих климатических изменений и повышения
                                требований к устойчивому развитию цифровые технологии становятся важным связующим звеном
                                между экономическими, социальными и экологическими приоритетами.
                            </div>
                            <div className={S.text}>
                                Особую актуальность исследование возможностей цифровизации приобретает в контексте
                                необходимости решения глобальных проблем устойчивого развития. Концепция устойчивого
                                развития включает в себя интеграцию вопросов экономического роста, социальной
                                ответственности и сохранения окружающей среды. В связи с этим, цифровизация энергетики
                                рассматривается как стратегический инструмент, способствующий достижению этих целей
                                путём оптимизации использования ресурсов , минимизации углеродного следа и создания
                                прозрачных, более эффективных экономических отношений.
                            </div>
                            <div className={S.text}>
                                Целью данного исследования является анализ влияния цифровизации экономических процессов
                                в энергетике на обеспечение устойчивого развития страны. В рамках работы поставлены
                                задачи: изучить направления цифровой трансформации в энергетической отрасли, оценить её
                                влияние на ключевые аспекты устойчивого развития и проанализировать практические
                                примеры, раскрывающие взаимосвязь между цифровыми решениями и устойчивостью
                                энергетических систем.
                            </div>
                            <div className={S.text}>
                                Гипотеза исследования заключается в том, что цифровизация экономических отношений в
                                энергетике способствует повышению прозрачности, эффективности и экологичности отрасли и,
                                таким образом, играет важную роль в достижении целей устойчивого развития.
                            </div>
                            <div className={S.hrefDiv}>
                                <span className={S.textBold}>Продолжение статьи по ссылке:</span>
                                <a href="https://jiht.ru/science/temp/39-48_%D0%90%D0%B1%D1%80%D0%B0%D0%BC%D0%BE%D0%B2_%E2%84%967_compressed.pdf?ysclid=mcbuti853s920718588"
                                >https://jiht.ru/science/temp/39-48_%D0%90%D0%B1%D1%80%D0%B0%D0%BC%D0%BE%D0%B2_%E2%84%967_compressed.pdf?ysclid=mcbuti853s920718588</a>
                            </div>
                        </div>
                        <div className={S.articleTitleDiv}>Читайте также</div>
                        <div className={S.articlesDiv}>
                            <div className={S.articleDiv} onClick={() => navigate('/article1')}>
                                <div className={S.pictureArticle}>
                                    <img src={article1} alt="article1"/>
                                </div>
                                <div className={S.articleDivText}>Ольга Калашникова, начальник управления экологии ПАО
                                    «Северсталь»: «Будущее
                                    принадлежит
                                </div>
                                <p className={S.articleDivDate}>26.02.2025</p>
                            </div>
                            <div className={S.articleDiv} onClick={() => navigate('/article3')}>
                                <div className={S.pictureArticle}>
                                    <img src={article3} alt="article3"/>
                                </div>
                                <div className={S.articleDivText}>Ум, сталь и трубы нашей эпохи</div>
                                <p className={S.articleDivDate}>25.06.2025</p>
                            </div>
                            <div className={S.articleDiv} onClick={() => navigate('/article4')}>
                                <div className={S.pictureArticle}>
                                    <img src={article4} alt="article4"/>
                                </div>
                                <div className={S.articleDivText}>Цифровизация в обучении ремонтников Уральской Стали
                                </div>
                                <p className={S.articleDivDate}>23.12.2024</p>
                            </div>
                        </div>
                    </div>
                    <div className={S.footer}>
                        <div onClick={() => navigate('/articles-list')}>← Назад к списку</div>
                    </div>
                </div>
            </div>
        </section>
    );
};